export default "__VITE_ASSET__769652a6__"